import type { SummarizeStore } from '@stores/ai-summarize/interfaces'

export const actions = {
  setBookingId (this: SummarizeStore, payload: SummarizeStore['bookingId']): void {
    this.bookingId = payload
  },
  setSummaryId (this: SummarizeStore, payload: SummarizeStore['summaryId']): void {
    this.summaryId = payload
  },
  setDuration (this: SummarizeStore, payload: SummarizeStore['duration']): void {
    this.duration = payload
  },
  setSpeakingTime (this: SummarizeStore, payload: SummarizeStore['speakingTime']): void {
    this.speakingTime = payload
  },
  setLessonDate (this: SummarizeStore, payload: SummarizeStore['lessonDate']): void {
    this.lessonDate = payload
  },
  setSummary (this: SummarizeStore, payload: SummarizeStore['summary']): void {
    this.summary = payload
  },
  setRecordingUrl (this: SummarizeStore, payload: SummarizeStore['recordingUrl']): void {
    this.recordingUrl = payload
  },
  setTopic (this: SummarizeStore, payload: SummarizeStore['topic']): void {
    this.topic = payload
  },
  setHighlights (this: SummarizeStore, payload: SummarizeStore['highlights']): void {
    this.highlights = payload
  },
  setHomeActivities (this: SummarizeStore, payload: SummarizeStore['homeActivities']): void {
    this.homeActivities = payload
  },
  setHomeTasks (this: SummarizeStore, payload: SummarizeStore['homeTasks']): void {
    this.homeTasks = payload
  },
  setRating (this: SummarizeStore, payload: SummarizeStore['rating']): void {
    this.rating = payload
  },
  setComment (this: SummarizeStore, payload: SummarizeStore['comment']): void {
    this.comment = payload
  },
  setSurvey (this: SummarizeStore, payload: SummarizeStore['survey']): void {
    this.survey = payload
  },
  setTitle (this: SummarizeStore, payload: SummarizeStore['title']): void {
    this.title = payload
  },
  setShow (this: SummarizeStore, payload: SummarizeStore['show']): void {
    this.show = payload
  },
  setLoading (this: SummarizeStore, payload: SummarizeStore['loading']): void {
    this.loading = payload
  },
  setBannerFeedback (this: SummarizeStore, payload: SummarizeStore['bannerFeedback']): void {
    this.bannerFeedback = payload
  },
  setSeekTime (this: SummarizeStore, payload: SummarizeStore['seekTime']): void {
    this.seekTime = payload
  },
  resetSummarizeData (this: SummarizeStore): void {
    this.show = false
    this.bookingId = null
    this.summaryId = null
    this.duration = null
    this.speakingTime = null
    this.lessonDate = null
    this.summary = null
    this.recordingUrl = null
    this.topic = null
    this.highlights = []
    this.homeActivities = []
    this.homeTasks = []
    this.seekTime = null
  },
}
